import { AccordionItem, type AccordionItemProps } from '@ui-kit/components/Accordion/Accordion';
import { cn } from '@ui-kit/utils';

const SPACING_CLASS = {
  0: 'gap-0',
  8: 'gap-2',
  16: 'gap-4',
  24: 'gap-6',
  32: 'gap-8',
} as const;

type Spacing = keyof typeof SPACING_CLASS;

type Props = AccordionItemProps & {
  spacing?: Spacing;
};

const AccordionStackItem = ({ spacing = 16, children, className, ...restProps }: Props) => (
  <AccordionItem className={className} {...restProps}>
    <div className={cn('flex flex-col', SPACING_CLASS[spacing])}>{children}</div>
  </AccordionItem>
);

export default AccordionStackItem;
